import React, { useState, useCallback } from 'react';
import MainMenu from './components/MainMenu';
import GameScreen from './components/GameScreen';
import ResultScreen from './components/ResultScreen';
import './App.css';

function App() {
  const [screen, setScreen] = useState('menu'); // 'menu' | 'game' | 'result'
  const [settings, setSettings] = useState(null);
  const [gameResult, setGameResult] = useState(null);

  const handleStart = useCallback((config) => {
    setSettings(config);
    setScreen('game');
  }, []);

  const handleGameEnd = useCallback((result) => {
    setGameResult(result);
    setScreen('result');
  }, []);

  const handleBackToMenu = useCallback(() => {
    setScreen('menu');
    setSettings(null);
    setGameResult(null);
  }, []);

  return (
    <div className="app">
      {screen === 'menu' && (
        <MainMenu onStart={handleStart} />
      )}
      {screen === 'game' && settings && (
        <GameScreen
          key={Date.now()}
          settings={settings}
          arcadeMode={settings?.arcadeMode || false}
          onGameEnd={handleGameEnd}
        />
      )}
      {screen === 'result' && gameResult && (
        <ResultScreen
          result={gameResult}
          settings={settings}
          onBackToMenu={handleBackToMenu}
        />
      )}
      <footer className="app-footer">
        Development: <a href="https://www.neujeffski.com" target="_blank" rel="noopener noreferrer">www.neujeffski.com</a>
      </footer>
    </div>
  );
}

export default App;
